<template>
  <v-container v-bind="bind_container" >
    <v-layout row wrap>
      <v-flex xs12 sm12 md12>
        <v-card>
          <v-card-text style="padding-bottom: 8px;">
            <!-- <v-layout row wrap>
              <v-flex xs10>
                <ais-search-box submit-title="search" :autofocus="true" />
              </v-flex>
              <v-flex xs2>
                <ais-clear/>
              </v-flex>
            </v-layout> -->

            <ais-dates-range-input attribute-name="publishDate" reactive>
            </ais-dates-range-input>
            <ais-refinement-list attribute-name="source" operator="or" style="margin-top: 10px;">
              <h4 slot="header" class="primary--text mb-2">Source</h4>
            </ais-refinement-list>
          </v-card-text>

          <v-expansion-panel
            :disabled="false"
            v-model="panel"
            expand>
            <v-expansion-panel-content>
              <template slot="header"><b>Bookmarks and Smart Tags</b></template>
              <v-card v-show="panel[0]">
                <v-card-text style="padding-top: 0px;">
                  <ais-pools v-if="authenticated" attribute-name="Pools" operator="or">
                    <h4 slot="header" class="primary--text mb-2">Bookmarks</h4>
                  </ais-pools>
                  <ais-refinement-list attribute-name="smartTags.n" operator="and">
                    <h4 slot="header" class="primary--text mb-2">Smart tags</h4>
                  </ais-refinement-list>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>

            <v-expansion-panel-content v-if="user && user.access_right[algolia_articles_index_name]['facet_skeleton']">
              <template slot="header"><b>TR Wiki filters</b></template>
              <v-card v-show="panel[1]">
                <v-card-text style="padding-top: 0px;">
                  <v-expansion-panel
                    :disabled="false"
                    v-model="subpanel"
                    class="sub_expansion_panel"
                    expand>
                    <v-expansion-panel-content  >
                      <template slot="header"><b>Travel Retailers</b></template>
                      <v-card v-show="subpanel[0]">
                        <v-card-text style="padding-top: 0px;">
                          <ais-refinement-list attribute-name="retailer.n" operator="and" :show-search-input="true" >
                            <h4 slot="header" class="primary--text mb-2">Retailer</h4>
                          </ais-refinement-list>
                          <ais-refinement-list attribute-name="retailBrand.n" operator="and" :show-search-input="true">
                            <h4 slot="header" class="primary--text mb-2">Related actors</h4>
                          </ais-refinement-list>
                        </v-card-text>
                      </v-card>
                    </v-expansion-panel-content>

                    <v-expansion-panel-content  >
                      <template slot="header"><b>Travel Suppliers</b></template>
                      <v-card v-show="subpanel[1]">
                        <v-card-text style="padding-top: 0px;">
                          <ais-refinement-list attribute-name="company.n" operator="and" :show-search-input="true">
                            <h4 slot="header" class="primary--text mb-2">Supplier</h4>
                          </ais-refinement-list>
                          <ais-refinement-list attribute-name="brand.n" operator="and" :show-search-input="true">
                            <h4 slot="header" class="primary--text mb-2">Brand</h4>
                          </ais-refinement-list>
                        </v-card-text>
                      </v-card>
                    </v-expansion-panel-content>
                    <v-expansion-panel-content>
                      <template slot="header"><b>Location</b></template>
                      <v-card v-show="subpanel[2]">
                        <v-card-text style="padding-top: 0px;">
                          <ais-refinement-list attribute-name="airport.n" operator="and" :show-search-input="true">
                            <h4 slot="header" class="primary--text mb-2">Airport</h4>
                          </ais-refinement-list>
                          <ais-refinement-list attribute-name="city.n" operator="and" :show-search-input="true">
                            <h4 slot="header" class="primary--text mb-2">City</h4>
                          </ais-refinement-list>
                          <ais-refinement-list attribute-name="country.n" operator="and" :show-search-input="true">
                            <h4 slot="header" class="primary--text mb-2">Country</h4>
                          </ais-refinement-list>
                          <ais-refinement-list attribute-name="region.n" operator="and" :sort-by="['name:asc']">
                            <h4 slot="header" class="primary--text mb-2">Region</h4>
                          </ais-refinement-list>
                        </v-card-text>
                      </v-card>
                    </v-expansion-panel-content>
                    <v-expansion-panel-content>
                      <template slot="header"><b>Categorization</b></template>
                      <v-card v-show="subpanel[3]">
                        <v-card-text style="padding-top: 0px;">
                          <ais-refinement-list attribute-name="category.n" operator="and" :show-search-input="true">
                            <h4 slot="header" class="primary--text mb-2">Category</h4>
                          </ais-refinement-list>
                        </v-card-text>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>

            <li class="v-expansion-panel__container" v-if="!user || !user.access_right[algolia_articles_index_name]['facet_skeleton']">
              <div class="v-expansion-panel__header" @click="setLoginSignupForm(true)">
                <b >
                  TR Wiki filters <v-icon style="color: #bbb; font-size:18px;">lock</v-icon>
                </b>
                <div class="v-expansion-panel__header__icon">
                  <v-icon class="btn_icone">fas fa-chevron-down</v-icon>
                </div>
              </div>
            </li>

          </v-expansion-panel>

        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import AisSearchBox from '../AisComponents/AisSearchBox'
import AisClear from '../AisComponents/AisClear'
import AisDatesRangeInput from '../AisComponents/AisDatesRangeInput'
import AisPools from '../AisComponents/AisPools'
import AisRefinementList from '../AisComponents/AisRefinementList'
import USER from '@/graphql/User.gql'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'PressSearchPanel',
  data () {
    return {
      user: false,
      panel: [(!this.$vuetify.breakpoint.mdAndDown), (!this.$vuetify.breakpoint.mdAndDown)],
      subpanel: [(false), (false), (false), (false)],
      algolia_articles_index_name: process.env.VUE_APP_ALGOLIA_ARTICLES_INDEX_NAME
    }
  },
  components: {
    AisSearchBox,
    AisClear,
    AisPools,
    AisDatesRangeInput,
    AisRefinementList
  },
  methods: {
    ...mapMutations(['setLoginSignupForm']),
  },
  computed: {
    ...mapState(['authenticated']),
    bind_container () {
      const binding = {}
      if (this.$vuetify.breakpoint.mdAndDown) binding.style = ' padding:0px;'
      return binding
    },
    bind_advanced_search () {
      const binding = {}
      if (this.$vuetify.breakpoint.mdAndDown) binding.style = ' padding:0px;'
      return binding
    }
  },
  apollo: {
    user: {
      query: USER,
      skip () {
        return !this.$auth0.isAuthenticated()
      }
    }
  }
}
</script>
<style>
.sub_expansion_panel {
  -webkit-box-shadow: none;
  box-shadow: none;
}
</style>
